<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
        <mat-label>Number of devices or racks</mat-label>
        <input matInput formControlName="count">
    </mat-form-field>
    <button mat-flat-button color="primary" type="submit">Save</button>
</form>